import { asyncComponent } from '@nzyme/vue-utils/asyncComponent.js';
import { Country } from '@sigma/common/i18n/Country.js';
import { formatLocale } from '@sigma/common/i18n/Locale.js';
import { getLocalizedRouteName } from '@sigma/common/routes/getLocalizedRouteName.js';
import { getLocalizedRoutePath } from '@sigma/common/routes/getLocalizedRoutePath.js';
export function createComponentRoute(route, options) {
    return {
        path: route.route.path,
        name: route.route.name,
        component: asyncComponent(options.component),
        props: true,
        meta: {
            name: route.route.name,
            layout: options.layout,
            auth: options.auth,
            key: options.key,
            seo: options.seo,
            def: route.route,
        },
        children: options.children,
    };
}
export function createRedirectRoute(route, options) {
    return {
        path: route.route.path,
        name: route.route.name,
        redirect: options.redirect,
        meta: {
            name: route.route.name,
            auth: options.auth,
            def: route.route,
        },
    };
}
export function* createLocalizedComponentRoute(route, options) {
    for (const [lang, path] of Object.entries(route.route.path)) {
        const component = typeof options.component === 'function' ? options.component : options.component[lang];
        if (!component) {
            continue;
        }
        for (const country of Country.options) {
            const locale = formatLocale(country, lang);
            yield {
                path: getLocalizedRoutePath(path, locale),
                name: getLocalizedRouteName(route.route.name, locale),
                component: asyncComponent(component),
                props: true,
                meta: {
                    name: route.route.name,
                    layout: options.layout,
                    auth: options.auth,
                    lang: lang,
                    country,
                    locale,
                    key: options.key,
                    seo: options.seo,
                    def: route.route,
                },
                children: options.children,
            };
        }
    }
}
export function* createLocalizedRedirectRoute(route, options) {
    for (const [lang, path] of Object.entries(route.route.path)) {
        for (const country of Country.options) {
            const locale = formatLocale(country, lang);
            const redirect = options.redirect(locale);
            yield {
                path: getLocalizedRoutePath(path, locale),
                name: getLocalizedRouteName(route.route.name, locale),
                redirect,
                meta: {
                    name: route.route.name,
                    auth: options.auth,
                    lang: lang,
                    country,
                    locale,
                    def: route.route,
                },
                children: options.children,
            };
        }
    }
}
//# sourceMappingURL=createRoute.js.map